/*
 *
 * Announcement constants
 *
 */

export const OPEN_BAR = 'claris-vnext/Announcement/OPEN_BAR';
export const CLOSE_BAR = 'claris-vnext/Announcement/CLOSE_BAR';
export const OPEN_DIALOG = 'claris-vnext/Announcement/OPEN_DIALOG';
export const CLOSE_DIALOG = 'claris-vnext/Announcement/CLOSE_DIALOG';
export const SET_IMAGE_LINK = 'claris-vnext/Announcement/SET_URL';


